import { render, staticRenderFns } from "./WishlistButton.vue?vue&type=template&id=b8387026&scoped=true&"
import script from "./WishlistButton.vue?vue&type=script&lang=js&"
export * from "./WishlistButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8387026",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8387026')) {
      api.createRecord('b8387026', component.options)
    } else {
      api.reload('b8387026', component.options)
    }
    module.hot.accept("./WishlistButton.vue?vue&type=template&id=b8387026&scoped=true&", function () {
      api.rerender('b8387026', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/WishlistButton.vue"
export default component.exports